"use strict";

var _toConsumableArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var useState = React.useState,
    useEffect = React.useEffect,
    useRef = React.useRef;
var isClient = typeof window === 'object';

var DRAF = function DRAF(callback) {
  return setTimeout(callback, 35);
};

var useSize = function useSize(element) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? Infinity : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? Infinity : _ref$height;

  if (!isClient) {
    return [typeof element === 'function' ? element({
      width: width,
      height: height
    }) : element, {
      width: width,
      height: height
    }];
  }

  var _useState = useState({
    width: width,
    height: height
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  if (typeof element === 'function') {
    element = element(state);
  }

  var style = element.props.style || {};
  var ref = useRef(null);
  var window = null;

  var setSize = function setSize() {
    var iframe = ref.current;
    var size = iframe ? {
      width: iframe.offsetWidth,
      height: iframe.offsetHeight
    } : {
      width: width,
      height: height
    };
    setState(size);
  };

  var onWindow = function onWindow(window) {
    window.addEventListener('resize', setSize);
    DRAF(setSize);
  };

  useEffect(function () {
    var iframe = ref.current;

    if (iframe.contentWindow) {
      window = iframe.contentWindow;
      onWindow(window);
    } else {
      var onLoad = function onLoad() {
        iframe.removeEventListener('load', onLoad);
        window = iframe.contentWindow;
        onWindow(window);
      };

      iframe.addEventListener('load', onLoad);
    }

    return function () {
      if (window) {
        window.removeEventListener('resize', setSize);
      }
    };
  }, [0]);
  style.position = 'relative';
  var sized = React.cloneElement.apply(React, [element, {
    style: style
  }].concat([React.createElement('iframe', {
    ref: ref,
    style: {
      background: 'transparent',
      border: 'none',
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
      zIndex: -1
    }
  })].concat(_toConsumableArray(React.Children.toArray(element.props.children)))));
  return [sized, state];
};

exports.default = useSize;